import { createContext } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  userId: null,
  username: '',
  profileImageUrl: '',
  guestOfMember: '',
  token: null,
  login: () => {},
  logout: () => {}
});
